// Copyright 2020 The Nakama Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React, { useState } from 'react';
import ShopConfiguration from './ShopConfiguration';
import './CoinManagement.scss';

const CoinManagement: React.FC = () => {
  const [error, setError] = useState<string | null>(null);

  return (
    <div className="coin-management-container">
      {/* Header */}
      <div className="coin-management-header">
        <h2 className="coin-management-title">🛒 Shop</h2>
      </div>

      {/* Error display */}
      {error && (
        <div className="alert alert-danger">
          <strong>Error:</strong> {error}
          <button 
            className="btn btn-sm ms-3" 
            onClick={() => setError(null)}
            style={{ background: 'transparent', border: 'none', cursor: 'pointer' }}
          >
            ✕
          </button>
        </div>
      )}

      {/* Shop Configuration */}
      <div className="tab-content">
        <ShopConfiguration onError={setError} />
      </div>
    </div>
  );
};

export default CoinManagement;
